export const SOFTWARE = {
  NB_OF_INSTANCES: {
    WITHOUT_SOFTWARE: 0,
    WITH_SOFTWARE: 2,
  },
};

export const MAX_FIELDS_VALUE = 99999;
